import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader } from 'material-ui/Card';
import { List } from 'material-ui/List';
import NotificationIcon from 'material-ui/svg-icons/social/notifications';
import { statusColours } from '../../constants/ColourConstants';
import ReminderListItem from './ReminderListItem';

const style = {
    list: {
        padding: 0,
        margin: 0,
    }
};

const ReminderSegmentAdmin = ({reminders, resourceId, resourceName}) => (
    <Card className="cent-card cent-card-12">
        <CardHeader
            title="Reminders"
            subtitle="manage reminder notifications"
            avatar={<NotificationIcon color={statusColours.default} />}
        />
        <List style={style.list}>
            {reminders.map( (reminder) => (
                    <ReminderListItem key={reminder.id} resourceId={resourceId} reminder={reminder} />
            ))}
        </List>
    </Card>
);

ReminderSegmentAdmin.propTypes = {
    resourceId: PropTypes.number.isRequired,
    resourceName: PropTypes.string.isRequired,
    reminders: PropTypes.array
};

ReminderSegmentAdmin.defaultProps = {
    reminders: []
};
export default ReminderSegmentAdmin;
